import { supabase, setUserContext, clearUserContext } from '../lib/supabase';
import { User } from '../types/database';

export class AuthService {
  static async login(phone: string): Promise<{ user: User | null; error: Error | null }> {
    try {
      console.log('[AUTH] Attempting login for phone:', phone);
      
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('phone', phone)
        .single();

      if (error) {
        console.error('[AUTH] Login error:', error);
        return { user: null, error: new Error('Invalid phone number') };
      }

      if (!data) {
        return { user: null, error: new Error('User not found') };
      }

      await setUserContext(phone);
      
      const user: User = {
        id: data.id,
        phone: data.phone,
        name: data.name,
        role: data.role,
        is_admin: Boolean(data.is_admin),
        created_at: data.created_at
      };

      localStorage.setItem('user', JSON.stringify(user));
      console.log('[AUTH] Login successful:', user.name);

      return { user, error: null };
    } catch (err) {
      console.error('[AUTH] Login exception:', err);
      return { user: null, error: err as Error };
    }
  }

  static async logout(): Promise<void> {
    console.log('[AUTH] Logging out');
    await clearUserContext();
    localStorage.removeItem('user');
  }

  static getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr) as User;
    } catch {
      return null;
    }
  }

  static isAuthenticated(): boolean {
    return this.getCurrentUser() !== null;
  }

  static isAdmin(): boolean {
    const user = this.getCurrentUser();
    return user?.is_admin === true;
  }
}
